import React from 'react';
import { motion } from 'framer-motion';
import styles from './FeatureCardSkeleton.module.css';

interface FeatureCardSkeletonProps {
  count?: number;
}

/**
 * FeatureCardSkeleton - Loading placeholder component
 * Displays animated skeleton placeholders while feature data is loading
 * Matches the dimensions and layout of actual FeatureCard components
 */
const FeatureCardSkeleton: React.FC<FeatureCardSkeletonProps> = ({
  count = 1
}) => {
  const skeletons = Array.from({ length: count }, (_, i) => i);

  return (
    <>
      {skeletons.map((index) => (
        <motion.div
          key={`skeleton-detail-${index}`}
          className={styles.skeletonCard}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.05 }}
          aria-label="Loading feature"
          role="status"
        >
          <div className={styles.skeletonHeader}>
            <div className={styles.skeletonTitleRow}>
              <div className={styles.skeletonTitle} />
              <div className={styles.skeletonBadge} />
            </div>
          </div>
        </motion.div>
      ))}
    </>
  );
};

export default FeatureCardSkeleton;
